// worklistSession.js
export const getWorklistContext = () => {
  const data = sessionStorage.getItem("worklistContext");
  return data ? JSON.parse(data) : null;
};

export const setWorklistContext = (context) => {
  sessionStorage.setItem("worklistContext", JSON.stringify(context));
};

export const clearWorklistContext = () => {
  sessionStorage.removeItem("worklistContext");
};
